module.exports = __webpack_public_path__ + "img/风险处置.0e43b689.png";